<template>
  <div class="dynamics">
    <div class="member_titleBOx">
      <p class="member_title">协会简报</p>
      <p class="dynamicsBtn" @click="gotoState()">查看更多 ></p>
    </div>
    <div class="dynamicsList">
      <div
        v-for="(item, index) in briefList"
        :key="index"
        class="dynamicsListBox"
        @click="gotoStateNews(item.uuid)"
      >
        <el-image
          style="width: 180px; height: 220px;border-radius: 10px ;display: block; margin: 0 auto;"
          :src="item.thumbnailPath"
        ></el-image>
        <h5>{{ item.name }}</h5>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "brief",
  props: {
    briefList: Array,
  },
  data() {
    return {};
  },
  methods: {
    gotoStateNews(uuid){
      let routeData = this.$router.resolve({
        name: "briefInfo",
        params: {
          uuid: uuid,
        },
      });
      window.open(routeData.href, "_blank");
    },
    gotoState() {
      let routeData = this.$router.resolve({
        name: "briefList",
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style scoped lang="less">
.dynamics {
  background: #F5F7FA;
  padding-bottom: 28px;
  padding-top: 22px;
  .member_titleBOx {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    .member_title {
      font-size: 24px;
      font-weight: 500;
    }
  }
  .dynamicsList {
    width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 217px 217px 217px 217px 217px;
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    .dynamicsListBox {
      background: #fff;
      border-radius: 8px;
      box-sizing: border-box;
      cursor: pointer;
      h5 {
        text-align: center;
        font-size: 16px;
        padding: 20px;
        padding-bottom: 0;
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      p {
        padding: 0 20px;
        font-size: 14px;
        color: #636366;
        margin: 7px 0 10px;
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
  .dynamicsBtn {
    cursor: pointer;
    color: #000;
    font-size: 13px;
    &:hover {
      color: #099;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/association/components/brief.vue